'use client';

import { Form, Formik } from 'formik';
import { ComponentProps, FC, useMemo, useState } from 'react';

import { FinanceEnquiryForm } from 'src/pdp/components/FinanceEnquiryForm/FinanceEnquiryForm';

import {
  FinanceCalculatorProps,
  FinanceEnquiryFormValidation,
  FinanceEnquiryFormValues,
} from '../../../hygiene/sections/FinanceCalculator/FinanceCalculator.type';
import { MyRepayment } from '../../../hygiene/sections/FinanceCalculator/components/MyRepayment/MyRepayment';
import styles from './FinancePdpCalculator.module.scss';

interface FinancePdpCalculatorProps extends FinanceCalculatorProps {
  purchasePrice: number;
  microcopy: {
    repayment: ComponentProps<typeof MyRepayment>['microcopy'];
    enquiryForm: ComponentProps<typeof FinanceEnquiryForm>['microcopy'];
  };
}

export const FinancePdpCalculator: FC<FinancePdpCalculatorProps> = ({
  purchasePrice,
  interestRateRange,
  loanTerms,
  onSubmit,
  microcopy,
}) => {
  const [isEnquiryFormOpen, setEnquiryFormOpen] = useState(false);
  const loanTermsArray = useMemo(
    () => Array.from({ length: loanTerms.max - loanTerms.min + 1 }, (_value, index) => loanTerms.min + index),
    [loanTerms],
  );

  const onSubmitForm = async (data: FinanceEnquiryFormValues) => {
    onSubmit(data);
    setEnquiryFormOpen(false);
  };

  return (
    <Formik
      initialValues={{
        weeklyPayment: 300,
        depositAmount: 0,
        interestRate: 10.02,
        purchasePrice,
        termOfLoan: 5,
        message: '',
        firstName: '',
        lastName: '',
        emailAddress: '',
        phoneNumber: '',
      }}
      onSubmit={onSubmitForm}
      validationSchema={FinanceEnquiryFormValidation}
    >
      {({ values, setFieldValue, handleSubmit, isSubmitting }) => {
        return (
          <Form className={styles.form}>
            <div className={styles.contentWrapper}>
              <MyRepayment
                loanTermsArray={loanTermsArray}
                interestRateRange={interestRateRange}
                values={values}
                setFieldValue={setFieldValue}
                microcopy={microcopy.repayment}
              />
            </div>
            <FinanceEnquiryForm
              isOpen={isEnquiryFormOpen}
              handleSubmit={handleSubmit}
              isSubmitting={isSubmitting}
              onClose={() => setEnquiryFormOpen(false)}
              microcopy={microcopy.enquiryForm}
            />
          </Form>
        );
      }}
    </Formik>
  );
};
